import React, { useState } from 'react';
import { StepContainer, StepNavigation, ChoiceButtons } from '../components';
import { StepProps, useFormContext } from '../context';

export const Step20E_TecnologiaRedes: React.FC<StepProps> = ({ onNext, onPrevious, isLoading }) => {
  const { data, updateField } = useFormContext();
  const [errors, setErrors] = useState<Record<string, string>>({});

  const handleNext = () => {
    const newErrors: Record<string, string> = {};

    if (!data.technologyConfidence) newErrors.technologyConfidence = 'Campo obrigatório';

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    onNext({ technologyConfidence: data.technologyConfidence });
  };

  const handleFieldChange = (value: string) => {
    updateField('technologyConfidence', value);
    if (errors.technologyConfidence) {
      setErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors.technologyConfidence;
        return newErrors;
      });
    }
  };

  return (
    <StepContainer title="">
      <div className="mb-6">
        <p className="font-semibold mb-4">Como você se sente em relação ao uso de tecnologias e redes sociais para vender?</p>
      </div>
      <div>
        <ChoiceButtons
          options={[
            { label: 'Muito confiante — adoro mexer com apps e redes!', value: 'very-confident' },
            { label: 'Confiante — uso bem, mas posso melhorar com orientações.', value: 'confident' },
            { label: 'Ainda não tenho muita prática, mas quero aprender.', value: 'learning' },
            { label: 'Não tenho prática e não tenho interesse em aprender.', value: 'not-interested' },
          ]}
          selected={data.technologyConfidence || ''}
          onSelect={handleFieldChange}
        />
        {errors.technologyConfidence && (
          <p className="text-red-600 text-sm mt-2">{errors.technologyConfidence}</p>
        )}
      </div>

      <StepNavigation onPrevious={onPrevious} onNext={handleNext} isLoading={isLoading} />
    </StepContainer>
  );
};

export default Step20E_TecnologiaRedes;
